import { Action, createReducer, on, props } from '@ngrx/store';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import {
  AddressBookItem,
  AddressBookListResponse,
  AssignedUsersResponse,
  CompantSiteTypeListResposne,
  CompanyItem,
  CompanyListResponse,
  CompanySiteItem,
  CompanySiteListResponse,
  CompanyTypeResponse,
} from '../../../api/models';
import { companiesActions } from './companies.actions';

export interface CompaniesState {
  list: {
    state: ILoaderActionPayload;
    data?: CompanyListResponse;
  };
  single: {
    state: ILoaderActionPayload;
    data?: CompanyItem;
  };
  uploadLogo: { state: ILoaderActionPayload; data?: CompanyItem };
  users: {
    state: ILoaderActionPayload;
    data?: AssignedUsersResponse;
  };
  assignUsers: { state: ILoaderActionPayload };
  addUsersToCompany: { state: ILoaderActionPayload };
  unassignUsers: { state: ILoaderActionPayload };
  removeUsersFromCompany: { state: ILoaderActionPayload };
  addressBook: {
    state: ILoaderActionPayload;
    data?: AddressBookListResponse;
  };
  addContactToAddressBook: { state: ILoaderActionPayload };
  addressBookContact: {
    state: ILoaderActionPayload;
    data?: AddressBookItem;
  };
  addressBookContactSaveOne: { state: ILoaderActionPayload };
  addressBookContactDeleteOne: { state: ILoaderActionPayload };
  saveOne: { state: ILoaderActionPayload; data?: CompanyItem };
  createOne: { state: ILoaderActionPayload; data?: CompanyItem };
  deleteOne: { state: ILoaderActionPayload; data?: CompanyItem };
  trashList: {
    state: ILoaderActionPayload;
    data?: CompanyListResponse;
  };
  forceDelete: { state: ILoaderActionPayload; data?: CompanyItem };
  restoreFromTrash: { state: ILoaderActionPayload; data?: CompanyItem };
  types: {
    state: ILoaderActionPayload;
    data?: CompanyTypeResponse;
  };
  companySiteList: {
    state: ILoaderActionPayload;
    data?: CompanySiteListResponse;
  };

  companySite: { state: ILoaderActionPayload; data?: CompanySiteItem };
  updateCompanySite: { state: ILoaderActionPayload; data?: CompanySiteItem };
  createCompanySite: { state: ILoaderActionPayload; data?: CompanySiteItem };
  moveCompanySiteToTrash: { state: ILoaderActionPayload; data?: CompanySiteItem };
  restoreCompanySite: { state: ILoaderActionPayload; data?: CompanySiteItem };
  companySiteTypes: {
    state: ILoaderActionPayload;
    data?: CompantSiteTypeListResposne;
  };
}

const initialState: CompaniesState = {
  list: { state: { value: LoadingState.NONE } },
  single: { state: { value: LoadingState.NONE } },
  uploadLogo: { state: { value: LoadingState.NONE } },
  users: { state: { value: LoadingState.NONE } },
  assignUsers: { state: { value: LoadingState.NONE } },
  addUsersToCompany: { state: { value: LoadingState.NONE } },
  unassignUsers: { state: { value: LoadingState.NONE } },
  removeUsersFromCompany: { state: { value: LoadingState.NONE } },
  addressBook: { state: { value: LoadingState.NONE } },
  addContactToAddressBook: { state: { value: LoadingState.NONE } },
  addressBookContact: { state: { value: LoadingState.NONE } },
  addressBookContactSaveOne: { state: { value: LoadingState.NONE } },
  addressBookContactDeleteOne: { state: { value: LoadingState.NONE } },
  saveOne: { state: { value: LoadingState.NONE } },
  createOne: { state: { value: LoadingState.NONE } },
  deleteOne: { state: { value: LoadingState.NONE } },
  trashList: { state: { value: LoadingState.NONE } },
  forceDelete: { state: { value: LoadingState.NONE } },
  restoreFromTrash: { state: { value: LoadingState.NONE } },
  types: { state: { value: LoadingState.NONE } },
  companySiteList: { state: { value: LoadingState.NONE } },
  companySite: { state: { value: LoadingState.NONE } },
  updateCompanySite: { state: { value: LoadingState.NONE } },
  createCompanySite: { state: { value: LoadingState.NONE } },
  moveCompanySiteToTrash: { state: { value: LoadingState.NONE } },
  companySiteTypes: { state: { value: LoadingState.NONE } },
  restoreCompanySite: { state: { value: LoadingState.NONE } },
};

const reducer = createReducer(
  initialState,
  // load
  on(companiesActions.load, (state) => ({
    ...state,
    list: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.done, (state, props) => ({
    ...state,
    list: { state: props.state, data: props.data },
  })),
  // loadOne
  on(companiesActions.loadOne, (state) => ({
    ...state,
    single: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.doneOne, (state, props) => ({
    ...state,
    single: { state: props.state, data: props.data },
  })),
  on(companiesActions.loadOneSetState, (state, props) => ({
    ...state,
    single: { state: { value: props.state.value, message: undefined } },
  })),
  // uploadLogo
  on(companiesActions.uploadLogo, (state) => ({
    ...state,
    uploadLogo: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.uploadLogoDone, (state, props) => ({
    ...state,
    uploadLogo: { state: props.state, data: props.data },
    single: state.single
      ? { state: { value: LoadingState.SUCCESS }, data: props.data }
      : { state: { value: LoadingState.NONE } },
  })),
  on(companiesActions.uploadLogoFail, (state, props) => ({
    ...state,
    uploadLogo: { state: props.state },
  })),
  on(companiesActions.uploadLogoSetState, (state, props) => ({
    ...state,
    uploadLogo: { state: { value: props.state.value, message: undefined } },
  })),
  //load user sede
  on(companiesActions.loadCompanySiteUsers, (state) => ({
    ...state,
    users: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.loadCompanySiteUsersDone, (state, props) => ({
    ...state,
    users: { state: props.state, data: props.data },
  })),

  // loadUsers azienda
  on(companiesActions.loadUsers, (state) => ({
    ...state,
    users: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.loadUsersDone, (state, props) => ({
    ...state,
    users: { state: props.state, data: props.data },
  })),
  // assignUsers
  on(companiesActions.assignUsers, (state) => ({
    ...state,
    assignUsers: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.assignUsersDone, (state, props) => ({
    ...state,
    assignUsers: { state: props.state },
  })),
  on(companiesActions.assignUsersSetState, (state, props) => ({
    ...state,
    assignUsers: { state: props.state },
  })),
  // addUsersToCompany
  on(companiesActions.addUsersToCompany, (state) => ({
    ...state,
    addUsersToCompany: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.addUsersToCompanyDone, (state, props) => ({
    ...state,
    addUsersToCompany: { state: props.state },
  })),
  on(companiesActions.addUsersToCompanySetState, (state, props) => ({
    ...state,
    addUsersToCompany: { state: props.state },
  })),
  // removeUsersFromCompany
  on(companiesActions.removeUsersFromCompany, (state) => ({
    ...state,
    removeUsersFromCompany: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.removeUsersFromCompanyDone, (state, props) => ({
    ...state,
    removeUsersFromCompany: { state: props.state },
  })),
  on(companiesActions.removeUsersFromCompanySetState, (state, props) => ({
    ...state,
    removeUsersFromCompany: { state: props.state },
  })),
  // unassignUsers
  on(companiesActions.unassignUsers, (state) => ({
    ...state,
    unassignUsers: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.unassignUsersDone, (state, props) => ({
    ...state,
    unassignUsers: { state: props.state },
  })),
  on(companiesActions.unassignUsersSetState, (state, props) => ({
    ...state,
    unassignUsers: { state: props.state },
  })),
  // load address book company
  on(companiesActions.loadAddressBook, (state) => ({
    ...state,
    addressBook: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.loadAddressBookDone, (state, props) => ({
    ...state,
    addressBook: { state: props.state, data: props.data },
  })),

  // load address book companySite
  on(companiesActions.loadCompanySiteAddressBook, (state) => ({
    ...state,
    addressBook: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.loadCompanySiteAddressBookDone, (state, props) => ({
    ...state,
    addressBook: { state: props.state, data: props.data },
  })),
  on(companiesActions.loadCompanySiteAddressBookSetState, (state, props) => ({
    ...state,
    addressBook: { state: props.state },
  })),

  // add contact to address book
  on(companiesActions.addContactoToAddressBook, (state) => ({
    ...state,
    addContactToAddressBook: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.addContactoToAddressBookDone, (state, props) => ({
    ...state,
    addContactToAddressBook: { state: props.state },
  })),
  on(companiesActions.addContactoToAddressBookSetState, (state, props) => ({
    ...state,
    addContactToAddressBook: { state: props.state },
  })),
  // delete contact to address book
  on(companiesActions.deleteOneAddressBookContact, (state) => ({
    ...state,
    addressBookContactDeleteOne: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.deleteOneAddressBookContactDone, (state, props) => ({
    ...state,
    addressBookContactDeleteOne: { state: props.state },
  })),
  on(companiesActions.deleteOneAddressBookContactSetState, (state, props) => ({
    ...state,
    addressBookContactDeleteOne: { state: props.state },
  })),
  // address book contact loadOne
  on(companiesActions.loadOneAddressBookContact, (state) => ({
    ...state,
    addressBookContact: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.loadOneDoneAddressBookContact, (state, props) => ({
    ...state,
    addressBookContact: { state: props.state, data: props.data },
  })),
  on(companiesActions.loadOneDoneAddressBookContactSetState, (state, props) => ({
    ...state,
    addressBookContact: { state: { value: props.state.value, message: undefined }, data: undefined },
  })),
  // address book contact saveOne
  on(companiesActions.saveOneAddressBookContact, (state) => ({
    ...state,
    addressBookContactSaveOne: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.saveOneDoneAddressBookContact, (state, props) => ({
    ...state,
    addressBookContactSaveOne: { state: props.state },
  })),
  on(companiesActions.saveOneDoneAddressBookContactSetState, (state, props) => ({
    ...state,
    addressBookContactSaveOne: { state: { value: props.state.value, message: undefined } },
  })),
  // saveOne
  on(companiesActions.saveOne, (state) => ({
    ...state,
    saveOne: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.saveOneDone, (state, props) => ({
    ...state,
    saveOne: { state: props.state, data: props.data },
  })),
  on(companiesActions.saveOneSetState, (state, props) => ({
    ...state,
    saveOne: { state: { value: props.state.value, message: undefined }, data: undefined },
  })),
  // createOne
  on(companiesActions.createOne, (state) => ({
    ...state,
    createOne: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.createOneDone, (state, props) => ({
    ...state,
    createOne: { state: props.state, data: props.data },
  })),
  on(companiesActions.createOneSetState, (state, props) => ({
    ...state,
    createOne: { state: { value: props.state.value, message: undefined }, data: undefined },
  })),
  // deleteOne
  on(companiesActions.moveToTrash, (state) => ({
    ...state,
    deleteOne: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.moveToTrashDone, (state, props) => ({
    ...state,
    deleteOne: { state: props.state, data: props.data },
  })),
  on(companiesActions.moveToTrashSetState, (state, props) => ({
    ...state,
    deleteOne: { state: { value: props.state.value, message: undefined }, data: undefined },
  })),
  // load trash
  on(companiesActions.loadTrash, (state) => ({
    ...state,
    trashList: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.loadTrashDone, (state, props) => ({
    ...state,
    trashList: { state: props.state, data: props.data },
  })),
  // deleteOne from trash
  on(companiesActions.forceDelete, (state) => ({
    ...state,
    forceDelete: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.forceDeleteDone, (state, props) => ({
    ...state,
    forceDelete: { state: props.state, data: props.data },
  })),
  on(companiesActions.forceDeleteSetState, (state, props) => ({
    ...state,
    forceDelete: { state: { value: props.state.value, message: undefined }, data: undefined },
  })),
  // restore company from trash
  on(companiesActions.restoreFromTrash, (state) => ({
    ...state,
    restoreFromTrash: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.restoreFromTrashDone, (state, props) => ({
    ...state,
    restoreFromTrash: { state: props.state, data: props.data },
  })),
  on(companiesActions.restoreFromTrashSetState, (state, props) => ({
    ...state,
    restoreFromTrash: { state: { value: props.state.value, message: undefined }, data: undefined },
  })),
  //company types
  on(companiesActions.loadGetTypes, (state) => ({
    ...state,
    list: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.doneGetTypes, (state, props) => ({
    ...state,
    types: { state: props.state, data: props.data },
  })),

  // companySite loadOne
  on(companiesActions.loadOneCompanySite, (state) => ({
    ...state,
    companySite: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.loadOneCompanySiteDone, (state, props) => ({
    ...state,
    companySite: { state: props.state, data: props.data },
  })),
  on(companiesActions.loadOneCompanySiteSetState, (state, props) => ({
    ...state,
    companySite: { state: { value: props.state.value } },
  })),

  // companySite load
  on(companiesActions.loadCompanySites, (state) => ({
    ...state,
    companySiteList: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.loadCompanySitesDone, (state, props) => ({
    ...state,
    companySiteList: { state: props.state, data: props.data },
  })),
  on(companiesActions.loadCompanySitesSetState, (state, props) => ({
    ...state,
    companySiteList: { state: props.state },
  })),

  // companySite create
  on(companiesActions.createCompanySite, (state) => ({
    ...state,
    createCompanySite: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.createCompanySiteDone, (state, props) => ({
    ...state,
    createCompanySite: { state: props.state, data: props.data },
  })),
  on(companiesActions.createCompanySiteSetState, (state, props) => ({
    ...state,
    createCompanySite: { state: props.state },
  })),
  // companySite update
  on(companiesActions.updateCompanySite, (state) => ({
    ...state,
    updateCompanySite: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.updateCompanySiteDone, (state, props) => ({
    ...state,
    updateCompanySite: { state: props.state, data: props.data },
  })),
  on(companiesActions.updateCompanySiteSetState, (state, props) => ({
    ...state,
    updateCompanySite: { state: props.state },
  })),

  // companySite deactivate
  on(companiesActions.moveCompanySiteToTrash, (state) => ({
    ...state,
    moveCompanySiteToTrash: { state: { value: LoadingState.LOADING } },
  })),
  // on(companiesActions.moveCompanySiteToTrashDone, (state, props) => {
  //   if (props.data) {
  //     let companySiteList = [...state.companySiteList.data.list];
  //     const i = companySiteList.findIndex((x) => x.id === props.data!.id);
  //     companySiteList[i] = props.data;
  //     return {
  //       ...state,
  //       moveCompanySiteToTrash: { state: props.state, data: props.data },

  //       ...(state.companySiteList && {
  //         companySiteList: {
  //           state: { value: LoadingState.SUCCESS },
  //           data: { ...state.companySiteList.data, list: companySiteList },
  //         },
  //         companySite: {
  //           state: { value: LoadingState.SUCCESS },
  //           data: {
  //             ...props.data,
  //             active: false,
  //           },
  //         },
  //       }),
  //       ...(state.companySite && {
  //         companySite: {
  //           state: { value: LoadingState.SUCCESS },
  //           data: {
  //             ...props.data,
  //             active: false,
  //           },
  //         },
  //       }),
  //     };
  //   } else {
  //     return { ...state, moveCompanySiteToTrash: { state: props.state, data: props.data } };
  //   }
  // }),
  on(companiesActions.moveCompanySiteToTrashDone, (state, props) => {
    if (props.data) {
      return {
        ...state,
        moveCompanySiteToTrash: { state: props.state, data: props.data },

        ...(state.companySiteList.data && {
          companySiteList: {
            state: { value: LoadingState.SUCCESS },
            data: {
              ...state.companySiteList.data,
              list: state.companySiteList.data.list.map((x) => (x.id === props.data!.id ? props.data! : x)),
            },
          },
        }),

        ...(state.companySite.data?.id === props.data.id && {
          companySite: {
            state: { value: LoadingState.SUCCESS },
            data: {
              ...state.companySite.data,
              active: false,
            },
          },
        }),
      };
    } else {
      return { ...state, moveCompanySiteToTrash: { state: props.state, data: props.data } };
    }
  }),
  on(companiesActions.moveCompanySiteToTrashSetState, (state, props) => ({
    ...state,
    moveCompanySiteToTrash: { state: props.state },
  })),

  // restore company site from trash
  on(companiesActions.restoreCompanySite, (state) => ({
    ...state,
    restoreCompanySite: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.restoreCompanySiteDone, (state, props) => {
    if (props.data) {
      return {
        ...state,
        restoreCompanySite: { state: props.state, data: props.data },

        ...(state.companySiteList.data && {
          companySiteList: {
            state: { value: LoadingState.SUCCESS },
            data: {
              ...state.companySiteList.data,
              list: state.companySiteList.data.list.map((x) => (x.id === props.data!.id ? props.data! : x)),
            },
          },
        }),

        ...(state.companySite.data?.id === props.data.id && {
          companySite: {
            state: { value: LoadingState.SUCCESS },
            data: {
              ...state.companySite.data,
              active: true,
            },
          },
        }),
      };
    } else {
      return { ...state, restoreCompanySite: { state: props.state, data: props.data } };
    }
  }),
  on(companiesActions.restoreCompanySiteSetState, (state, props) => ({
    ...state,
    restoreCompanySite: { state: { value: props.state.value, message: undefined }, data: undefined },
  })),

  // companySiteType load
  on(companiesActions.loadCompanySiteTypes, (state) => ({
    ...state,
    companySiteTypes: { state: { value: LoadingState.LOADING } },
  })),
  on(companiesActions.loadCompanySiteTypesDone, (state, props) => ({
    ...state,
    companySiteTypes: { state: props.state, data: props.data },
  })),
  on(companiesActions.loadCompanySiteTypesSetState, (state, props) => ({
    ...state,
    companySiteTypes: { state: props.state },
  })),
);

export function companiesReducer(state: CompaniesState | undefined, action: Action) {
  return reducer(state, action);
}
